import { MemoryStorage, OAuthStorage } from 'angular-oauth2-oidc';

export class NamespacedOAuthStorage implements OAuthStorage {
  private readonly storage: OAuthStorage;

  constructor(private readonly namespace: string) {
    this.storage =
      typeof sessionStorage === 'undefined'
        ? new MemoryStorage()
        : sessionStorage;
  }

  getItem(key: string): string | null {
    return this.storage.getItem(this.toNamespacedKey(key));
  }

  removeItem(key: string): void {
    this.storage.removeItem(this.toNamespacedKey(key));
  }

  setItem(key: string, data: string): void {
    this.storage.setItem(this.toNamespacedKey(key), data);
  }

  private toNamespacedKey(key: string): string {
    return `${this.namespace}.${key}`;
  }
}
